import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import {
	BindCategoryDto,
	BindRequestDto,
	CategoryGroup,
	ShopTopic,
	ShopTopicState,
	TelegramBindStatus,
} from '../model';
import {
	TELEGRAM_BIND_KEY,
	TELEGRAM_CATEGORY_GROUPS_KEY,
	TELEGRAM_OUTBOX_KEY,
	TELEGRAM_SHOP_TOPICS_KEY,
	TELEGRAM_TAG_TOPICS_KEY,
} from './telegram.queries';

const TELEGRAM = `/api/admin/telegram`;

export const useBindTelegramGroup = () => {
	const queryClient = useQueryClient();

	return useMutation<TelegramBindStatus, any, BindRequestDto>(
		TELEGRAM_BIND_KEY,
		async request => {
			const { data } = await axios.post(`${TELEGRAM}/bind`, request);
			return data;
		},
		{
			onSuccess: () => {
				queryClient.invalidateQueries(TELEGRAM_BIND_KEY);
				queryClient.invalidateQueries(TELEGRAM_TAG_TOPICS_KEY);
			},
		}
	);
};

export const useUnbindTelegramGroup = () => {
	const queryClient = useQueryClient();

	return useMutation<TelegramBindStatus, any, void>(
		TELEGRAM_BIND_KEY,
		async () => {
			const { data } = await axios.delete(`${TELEGRAM}/bind`);
			return data;
		},
		{
			onSuccess: () => {
				queryClient.invalidateQueries(TELEGRAM_BIND_KEY);
				// Отвязка сбрасывает и привязку тем — список должен опустеть
				queryClient.invalidateQueries(TELEGRAM_TAG_TOPICS_KEY);
			},
		}
	);
};

export const useBindCategoryGroup = () => {
	const queryClient = useQueryClient();

	return useMutation<CategoryGroup, any, BindCategoryDto>(
		TELEGRAM_CATEGORY_GROUPS_KEY,
		async request => {
			const { data } = await axios.post(`${TELEGRAM}/categories`, request);
			return data;
		},
		{
			onSuccess: () => {
				queryClient.invalidateQueries(TELEGRAM_CATEGORY_GROUPS_KEY);
			},
		}
	);
};

export const useUnbindCategoryGroup = () => {
	const queryClient = useQueryClient();

	return useMutation<void, any, number>(
		TELEGRAM_CATEGORY_GROUPS_KEY,
		async categoryId => {
			await axios.delete(`${TELEGRAM}/categories/${categoryId}`);
		},
		{
			onSuccess: () => {
				queryClient.invalidateQueries(TELEGRAM_CATEGORY_GROUPS_KEY);
				queryClient.invalidateQueries(TELEGRAM_SHOP_TOPICS_KEY);
			},
		}
	);
};

export const useUpdateShopTopicState = () => {
	const queryClient = useQueryClient();

	return useMutation<
		ShopTopic,
		any,
		{ topicUuid: string; state: ShopTopicState }
	>(
		TELEGRAM_SHOP_TOPICS_KEY,
		async ({ topicUuid, state }) => {
			const { data } = await axios.patch(
				`${TELEGRAM}/shop-topics/${topicUuid}`,
				{ state }
			);
			return data;
		},
		{
			onSuccess: () => {
				queryClient.invalidateQueries(TELEGRAM_SHOP_TOPICS_KEY);
			},
		}
	);
};


export const useRetryOutbox = () => {
	const queryClient = useQueryClient();

	return useMutation<void, any, string>(
		TELEGRAM_OUTBOX_KEY,
		async outboxUuid => {
			await axios.post(`${TELEGRAM}/outbox/${outboxUuid}/retry`);
		},
		{
			onSuccess: () => {
				queryClient.invalidateQueries(TELEGRAM_OUTBOX_KEY);
			},
		}
	);
};
